import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, ButtonGroup } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
// The supported logical operators.
const logicalOperators = ['AND', 'OR'];
export const ElevionLogicalOp = ({ activeOp, readOnly, parentName, }) => {
    const { setValue } = useFormContext();
    const handleOperatorClick = useCallback((operator) => {
        setValue(`${parentName}.logicalOp`, operator);
    }, [parentName, setValue]);
    return (_jsx(Box, Object.assign({ margin: "200 0 200 200" }, { children: _jsx(ButtonGroup, { children: logicalOperators.map((operator) => (_jsx(Button, Object.assign({ variant: operator === activeOp ? 'primary' : 'secondary', disabled: readOnly, onClick: operator === activeOp
                    ? undefined
                    : () => handleOperatorClick(operator) }, { children: operator }), operator))) }) })));
};
